import { type ReactNode } from 'react';
import classNames from 'classnames';

import { Accordion } from '~/vendor/cxy/components/Accordion';

import styles from './FAQ.module.css';

type FAQItem = {
  content: ReactNode[];
  heading: string;
};

type FAQComponentProps = {
  children: ReactNode;
  className?: string;
};

type TitleProps = {
  children: ReactNode;
  className?: string;
};

type SubtitleProps = {
  children: ReactNode;
  className?: string;
};

type ListProps = {
  className?: string;
  items: FAQItem[];
};

function FAQ({ children, className }: FAQComponentProps) {
  return (
    <section className={classNames(styles.section, className)} data-testid="faq-section">
      {children}
    </section>
  );
}

function Title({ children, className }: TitleProps) {
  return (
    <h2 className={classNames(styles.sectionTitle, className)} data-testid="faq-title">
      {children}
    </h2>
  );
}

function Subtitle({ children, className }: SubtitleProps) {
  return (
    <p className={classNames(styles.sectionDescription, className)} data-testid="faq-subtitle">
      {children}
    </p>
  );
}

function List({ className, items }: ListProps) {
  return (
    <div className={className}>
      <Accordion name="faqs" type="multiple" variant="secondary">
        {items.map(({ content, heading }, itemIndex) => (
          <Accordion.Item
            data-analytics={`faqs-${itemIndex + 1}`}
            heading={heading}
            key={`accordion-item-${itemIndex}`}
            trackingAttribute={`faqs-${itemIndex + 1}`}
          >
            {content.map((paragraph, paragraphIndex) => (
              <p className={styles.accordionContent} key={`accordion-item-${itemIndex}-paragraph-${paragraphIndex}`}>
                {paragraph}
              </p>
            ))}
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
}

FAQ.Title = Title;
FAQ.Subtitle = Subtitle;
FAQ.List = List;

export type { FAQItem };
export { FAQ };
